import { render } from "./ActionsNewAttachmentModal.vue?vue&type=template&id=5051474e"
import script from "./ActionsNewAttachmentModal.vue?vue&type=script&lang=js"
export * from "./ActionsNewAttachmentModal.vue?vue&type=script&lang=js"

import "./ActionsNewAttachmentModal.vue?vue&type=style&index=0&id=5051474e&lang=scss"
import "./ActionsNewAttachmentModal.vue?vue&type=style&index=1&id=5051474e&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__